import React, {
    useEffect,
    useState
} from "react";

import {
    IonAlert,
    IonApp,
    setupIonicReact
} from "@ionic/react";

import {
    checkForAppUpdate,
    clearSavedAppVersion
} from "./services/appVersion";

import Tabs from "./pages/Tabs";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";

setupIonicReact();

const App: React.FC = () => {
    const [updateAvailable, setUpdateAvailable] =
        useState(false);

    useEffect(function () {
        let active = true;

        async function verifyUpdate(): Promise<void> {
            const hasUpdate = await checkForAppUpdate();

            if (active && hasUpdate) {
                setUpdateAvailable(true);
            }
        }

        verifyUpdate();

        const intervalId = window.setInterval(
            verifyUpdate,
            5 * 60 * 1000
        );

        return function () {
            active = false;

            window.clearInterval(intervalId);
        };
    }, []);

    useEffect(function () {
    function reloadAfterServiceWorkerChange(): void {
        window.location.reload();
    }

    navigator.serviceWorker?.addEventListener(
        "controllerchange",
        reloadAfterServiceWorkerChange
    );

    return function () {
        navigator.serviceWorker?.removeEventListener(
            "controllerchange",
            reloadAfterServiceWorkerChange
        );
    };
}, []);


function applyUpdate(): void {
    clearSavedAppVersion();

    navigator.serviceWorker
        .getRegistration()
        .then(function (registration) {
            if (registration?.waiting) {
                registration.waiting.postMessage({
                    type: "SKIP_WAITING"
                });

                return;
            }

            window.location.reload();
        })
        .catch(function () {
            window.location.reload();
        });
}


    return (
        <IonApp>
            <Tabs />

            <IonAlert
                isOpen={updateAvailable}
                header="Actualización disponible"
                message={
                    "Hay una versión nueva de MexFBA. " +
                    "Actualiza para ver los cambios."
                }
                backdropDismiss={false}
                buttons={[
                    {
                        text: "Actualizar",
                        handler: applyUpdate
                    }
                ]}
            />
        </IonApp>
    );
};

export default App;
